import { RefObject, useEffect } from "react";
import { addUserEventSourceListener } from "@/common/hooks/event-source/useUserApiEventSource.ts";
import { TRACK_SOURCE_CHANGED } from "@/common/sse-api-event-source-message-types";
import { useMutateExplorerItems } from "@/state/jotai/hooks/useMutateExplorerItems.ts";
import { emitEvent } from "@/services/event-emitter.ts";
import { EventTypes } from "@/types/types.ts";

function useTrackSourceChanged(eventSourceRef: RefObject<EventSource | null>) {
  const { updateItem } = useMutateExplorerItems();

  // TRACK_SOURCE_CHANGED Listener
  useEffect(() => {
    if (!eventSourceRef.current) return;

    const handleTrackSourceChanged = (e: MessageEvent) => {
      const { explorerItem } = JSON.parse(e.data);
      updateItem(explorerItem);
      emitEvent(EventTypes.INIT_AUDIO_EDITOR_PEAKS, { force: true });
    };

    const removeListener = addUserEventSourceListener(
      eventSourceRef.current,
      TRACK_SOURCE_CHANGED,
      handleTrackSourceChanged,
    );

    // Cleanup
    return () => {
      removeListener();
    };
  }, [
    eventSourceRef,
    updateItem
  ]);
}

export default useTrackSourceChanged;
